import { Component } from 'san';
import * as _ from 'lodash';
import {
    IUser
} from 'src/models';
import Pagination from '../Pagination/Pagination';

export default class CheckOrgUsersList extends Component {
    static components = {
        'ui-pagination': Pagination
    }

    static computed = {
        isCheckedAll() {
            const users = this.data.get('users');
            const checkedUsers = _.filter(users, { _is_checked: true });
            return checkedUsers.length > 0 && checkedUsers.length === users.length;
        }
    }

    constructor(options: any) {
        super(options);
    }

    initData(): {
        isMultiple: boolean;    // {{}}
        isShowPagination: boolean;    // {{}}
        users: IUser[];    // {{}}
        count: number;    // {{}}
        page: number;    // {{}}
        limit: number;  // {{}}
    } {
        return {
            isMultiple: false,
            isShowPagination: true,
            users: [],
            count: 0,
            page: 1,
            limit: 8
        };
    }

    inited() {
    }

    onPageChange(pageParams: { page: number; limit: number; }) {
        this.dispatch('UI:check-org-users-list-page-changed', pageParams.page);
    }

    toggleCheckAll() {
        const isCheckedAll = !this.data.get('isCheckedAll');
        isCheckedAll ? this.checkAll() : this.unCheckAll();
    }

    private checkAll() {
        if (!this.data.get('isMultiple')) {
            return;
        }
        const users: IUser[] = this.data.get('users');
        _.forEach(users, user => {
            user._is_checked = true;
        });
        this.dispatchCheckedChangedUsers(users);
    }

    private unCheckAll() {
        if (!this.data.get('isMultiple')) {
            return;
        }
        const users: IUser[] = this.data.get('users');
        _.forEach(users, user => {
            user._is_checked = false;
        });
        this.dispatchCheckedChangedUsers(users);
    }

    checkUser(user: IUser) {
        if (this.data.get('isMultiple')) {
            user = _.cloneDeep(user);
            user._is_checked = !user._is_checked;
            this.dispatchCheckedChangedUsers([user]);
        } else {
            const users: IUser[] = this.data.get('users');
            _.forEach(users, item => {
                item._is_checked = item.user_id === user.user_id;
            });
            this.dispatchCheckedChangedUsers(users);
        }
    }

    // dispatch _is_checked状态发生变化的users
    // (如果是单选， 应该将users列表全部dispatch)
    dispatchCheckedChangedUsers(users: IUser[]) {
        this.dispatch('UI:check-org-users-changed', users);
    }
    
}